module.exports = __webpack_public_path__ + "static/media/CL_Logo_White+Lemon_Stacked.b554b039.png";